// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__30c13","title":"Info_title__1iCyz","links":"Info_links__1y5l1","link":"Info_link__2R9ZD","logo":"Info_logo__l3Y2M"};